let merchantChannel = null;

export const SetMerchantChannel = (merchantId) => {
  if (merchantChannel) {
    merchantChannel.close();
  }
  merchantChannel = new BroadcastChannel(merchantId);

  merchantChannel.onmessage = (event) => {};
};

export const BroadcastInMerchantChannel = () => {
  if (merchantChannel) {
    merchantChannel.postMessage("Test");
  }
};
